const DefaultToString = function () {
  return ""
}

export default DefaultToString
